import { render, staticRenderFns } from "./bookCorrect.vue?vue&type=template&id=85cb904a&"
import script from "./bookCorrect.vue?vue&type=script&lang=js&"
export * from "./bookCorrect.vue?vue&type=script&lang=js&"
import style0 from "./bookCorrect.vue?vue&type=style&index=0&id=85cb904a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports